import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "../App.css"

export default function SquareGame() {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const move = (dx, dy) => {
    setPosition({ x: position.x + dx, y: position.y + dy });
  };

  // Event listener pentru taste
  useEffect(() => {
    const handleKeyDown = (e) => {
      switch (e.key) {
        case "ArrowUp":
          move(0, -20);
          break;
        case "ArrowDown":
          move(0, 20);
          break;
        case "ArrowLeft":
          move(-20, 0);
          break;
        case "ArrowRight":
          move(20, 0);
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [position]);

  return (
    <div className="app">
      <h1>Mini-joc React 🎮</h1>

      {/* Zona de joc */}
      <div className="game-area">
        <motion.div
          className="player"
          animate={{ x: position.x, y: position.y }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
        />
      </div>

      {/* Controale */}
        <div className="controls">
        <button className="empty"></button>
        <button onClick={() => move(0, -20)}>⬆️</button>
        <button className="empty"></button>

        <button onClick={() => move(-20, 0)}>⬅️</button>
        <button className="empty"></button>
        <button onClick={() => move(20, 0)}>➡️</button>

        <button className="empty"></button>
        <button onClick={() => move(0, 20)}>⬇️</button>
        <button className="empty"></button>
        </div>
    </div>
  );
}
